import React from "react";
import { Typography } from "@material-ui/core";

import PersonIcon from "@material-ui/icons/Person";
import WorkIcon from "@material-ui/icons/Work";
import HomeIcon from "@material-ui/icons/Home";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import brandTheme from "brandTheme/Theme";

const applicationCards = [
  {
    title: "Personal Information",
    icon: <PersonIcon />,
    items: ["Mobile Number", "Email Address", "Date of Birth", "PAN Card"],
  },
  {
    title: "Employment Details",
    icon: <WorkIcon />,
    items: ["Company Name", "Designation", "Monthly Income", "Work Experience"],
  },
  {
    title: "Address Information",
    icon: <HomeIcon />,
    items: ["Current Address", "Permanent Address", "PIN Code"],
  },
  {
    title: "Banking Information",
    icon: <AccountBalanceIcon />,
    items: ["Bank Account", "IFSC Code", "Bank Statement"],
  },
];

const ApplicationRequirements = () => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
        gap: 20,
      }}
    >
      {applicationCards.map((card) => (
        <div
          key={card.title}
          style={{
            background: "#FFFFFF",
            borderRadius: 18,
            padding: 24,
            boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
            border: "1px solid #EEF3F1",
            minHeight: 220,
            display: "flex",
            justifyContent:"space-around"
          }}
        >
            <div
              style={{
                width: 54,
                height: 54,
                borderRadius: "50%",
                background: brandTheme.backgroundColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {React.cloneElement(card.icon, {
                style: {
                  fontSize: 28,
                  color: "#1CB167",
                },
              })}
            </div>
              <div>
       
     <Typography
              variant="h6"
              style={{
                fontWeight: 700,
                color: "#15254F",
                lineHeight: 2.5,
              }}
            >
              {card.title}
            </Typography>
          {card.items.map((item) => (
            <Typography
              key={item}
              variant="body2"
              style={{
                marginBottom: 10,
                color: "#4F5D75",
                display: "flex",
                alignItems: "center",
                lineHeight: 1.7,
                fontSize:'15px'
              }}
            >
              <span
                style={{
                  color: "#1CB167",
                  marginRight: 10,
                  fontWeight: 700,
                }}
              >
                •
              </span>

              {item}
            </Typography>
          ))}
          </div>
          </div>
      ))}
    </div>
  );
};

export default ApplicationRequirements;
